import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services';
import { WasherModel } from '../../../models';

@Component({
    selector: 'app-washers',
    templateUrl: './washers.component.html',
    styleUrls: ['./washers.component.scss'],
})
export class WashersComponent {
    @Input()
    set boltType(value: string) {
        this._boltType = value;
        this.getWasherDimensions();
    }
    get boltType(): string {
        return this._boltType;
    }

    @Input()
    set boltSize(value: number) {
        this._boltSize = value;
        this.getWasherDimensions();
    }
    get boltSize(): number {
        return this._boltSize;
    }

    @Input()
    set pressureClassId(value: string) {
        this._pressureClassId = value;
        this.getWasherDimensions();
    }
    get pressureClassId(): string {
        return this._pressureClassId;
    }

    @Input()
    set pipeSizeId(value: string) {
        this._pipeSizeId = value;
        this.getWasherDimensions();
    }
    get pipeSizeId(): string {
        return this._pipeSizeId;
    }
    @Input() form: UntypedFormGroup;

    tooltip_position = 'above';
    loading: boolean = false;
    washerList: WasherModel[];

    private _boltType: string;
    private _boltSize: number;
    private _pressureClassId: string;
    private _pipeSizeId: string;

    constructor(
        private iceapi: IceapiService,
        private user_utility: UserUtilityService
    ) {}

    getWasherDimensions(): void {
        this.form.get('washer').setValue(0);
        if (this.boltSize !== undefined || (this.boltType != undefined && this.pressureClassId !== undefined && this.pipeSizeId !== undefined)) {
            this.loading = true;
            this.iceapi
                .getWasherDimensions(this.boltType, this.pressureClassId, this.pipeSizeId, this.boltSize)
                .pipe(
                    finalize(() => {
                        this.loading = false;
                    })
                )
                .subscribe((washers) => {
                    if (washers.success === true) {
                        this.washerList = washers.response;
                        if (this.washerList.length === 1) this.form.get('washer').setValue(this.washerList[0].washerDimensionId);
                    } else {
                        this.user_utility.errorModelPopup(washers.message);
                    }
                });
        }
    }
}
